function initBannerMediaScroll() {
  if (!gsap || !ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);
  const images = gsap.utils.toArray('.banner__media img');
  if (!images.length) return;

  images.forEach((img) => {
    if (img.dataset.scrollInit) return;
    img.dataset.scrollInit = true;

    gsap.fromTo(
      img,
      { scale: 1.3 },
      {
        scale: 1,
        duration: 2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: img,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
      }
    );
  });
}

document.addEventListener('DOMContentLoaded', initBannerMediaScroll);
document.addEventListener('shopify:section:load', initBannerMediaScroll);
document.addEvent
